import React, { useContext, useEffect, useState } from "react";
import { Authcontext } from "../context/Authcontext";
const Onlysupport=(props)=>{
    const {usertype}= useContext(Authcontext);
    if (usertype === "support") {
        return props.children;
    }
    return null
}
export default Onlysupport;